<template>
  <v-card :elevation="6" class="mx-auto pa-2 rounded-lg" style="min-height: 320px;">
    <grafico-vazio v-if="dados.length === 0" :min-height="320" />
      <grafico-rosca
      v-else
        id="grafico-tipos-verba"
        :category-field="`nome`"
        :value-fields="valueFields"
        :dados="dados"
        :title="`R$ ${$t('label.tipos_de_verbas', 1)}`"
      />
  </v-card>
</template>

<script>
import GraficoRosca from '@/produto/shared-components/chart/GraficoRosca';
import { getMoney } from '@/produto/common/functions/numeric';
import { buscarTipoVerba } from '@/common/resources/akzo-chart';
import GraficoVazio from './GraficoVazio';

export default {
  name: 'GraficoRoscaTiposVerba',
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    params: {
      handler() {
        this.buscarDados();
      },
      deep: true,
    },
  },
  components: {
    GraficoRosca,
    GraficoVazio,
  },
  data() {
    return {
      dados: [],
      valueFields: {},
      cores: ['#3e64b7', '#878787', '#f639f1', '#3887cc', '#4cd73c', '#cbf14f', '#30006f', '#795548'],
    };
  },
  methods: {
    getBalloonText() {
      return [
        "<div style='text-align:left; font-size:14px'>",
        '<span>[[title]]</span>',
        '<br>',
        '<span>R$ [[value]] ([[percents]]%)</span>',
        '</div>',
      ].join('');
    },
    buscarDados() {
      buscarTipoVerba(this.params, this.$resource)
        .then((response) => {
          this.dados = (response.data || [])
            .filter((item) => item.id !== null)
            .map((item, index) => ({
              nome: item.nome || this.$tc('label.tinting', 1),
              valor: item.valor || 0,
              valorFormatado: getMoney(item.valor || 0),
              color: this.cores[index % this.cores.length],
            }));

          this.valueFields = {
            valueField: 'valor',
            titleField: 'nome',
            outlineAlpha: 0.4,
            balloonText: this.getBalloonText(),
            precision: 2,
            decimalSeparator: ',',
            thousandsSeparator: '.',
            colorField: 'color',
            labelText: 'R$ [[value]]\n([[percents]]%)',
          };
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
  },
  mounted() {
    this.buscarDados();
  },
};
</script>
